import { DisplaySelection } from '../models/DisplaySelection';
import { SetDisplayModeAction, SearchActionTypes } from './ActionTypes';

export function setDisplayMode(displaySelection: DisplaySelection): SetDisplayModeAction {
  return {
    type: SearchActionTypes.SET_DISPLAY_MODE,
    displaySelection: displaySelection,
  };
}
